// ═══════════════════════════════════════════════════════════════
// REPORT OPTIONS PANEL — Sélection des sections du rapport PDF
// ═══════════════════════════════════════════════════════════════

export const DEFAULT_SECTIONS = {
  description:        true,
  terrain:            true,
  contraintes:        true,
  alternative:        true,
  tableau_comparatif: true,
  alertes:            true,
  solutions_ecartees: true,
  dialogue_expert:    true,
};

const SECTIONS_CONFIG = [
  { key: "description",        label: "Description du projet",       desc: "Type d'ouvrage, dimensions, sol" },
  { key: "terrain",            label: "Données terrain",             desc: "Stratigraphie et coupe géologique" },
  { key: "contraintes",        label: "Contraintes du projet",       desc: "Sismique, nappe, surcharge" },
  { key: "alternative",        label: "Solution alternative",        desc: "2ème solution analysée" },
  { key: "tableau_comparatif", label: "Tableau comparatif",          desc: "Comparaison de toutes les solutions" },
  { key: "alertes",            label: "Alertes techniques",          desc: "Règles EC7 / GEO5 déclenchées" },
  { key: "solutions_ecartees", label: "Solutions écartées",          desc: "Solutions exclues par règles expertes" },
  { key: "dialogue_expert",   label: "§8 — Dialogue expert",        desc: "Q/R sélectionnées depuis l'Analyse IA" },
];

const OBLIGATOIRES = [
  "En-tête & référence",
  "Fiche projet",
  "Analyse principale (solution recommandée)",
  "Avertissement réglementaire",
];

const C = {
  bleu:   "#1a3a5c",
  gris:   "#6b7280",
  border: "#d1d5db",
  grisCl: "#f3f4f6",
  vert:   "#15803d",
};

function ReportOptionsPanel({ sectionsActives, onToggle }) {
  const activeCount = Object.values(sectionsActives).filter(Boolean).length;

  return (
    <div style={{
      background: "#f8fafc",
      border: `1.5px solid ${C.border}`,
      borderRadius: 10,
      padding: "16px 20px",
      marginBottom: 20,
      maxWidth: 900,
    }}>
      <div style={{
        display: "flex", justifyContent: "space-between", alignItems: "center",
        marginBottom: 14,
      }}>
        <div style={{ fontSize: 13, fontWeight: 800, color: C.bleu }}>
          🗂️ Sections du rapport
        </div>
        <div style={{
          fontSize: 11, fontWeight: 700, color: C.vert,
          background: "#f0fdf4", border: "1px solid #bbf7d0",
          borderRadius: 99, padding: "3px 12px",
        }}>
          {activeCount}/{SECTIONS_CONFIG.length} sections incluses
        </div>
      </div>

      {/* Sections optionnelles — checkboxes */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px 24px", marginBottom: 14 }}>
        {SECTIONS_CONFIG.map(({ key, label, desc }) => (
          <label
            key={key}
            style={{
              display: "flex", alignItems: "flex-start", gap: 8,
              cursor: "pointer", fontSize: 12, color: "#1a1a1a",
              minWidth: 220,
            }}
          >
            <input
              type="checkbox"
              checked={sectionsActives[key] !== false}
              onChange={() => onToggle(key)}
              style={{ marginTop: 2, accentColor: C.bleu, cursor: "pointer" }}
            />
            <div>
              <div style={{ fontWeight: 600 }}>{label}</div>
              <div style={{ color: C.gris, fontSize: 11 }}>{desc}</div>
            </div>
          </label>
        ))}
      </div>

      {/* Sections obligatoires — affichage grisé */}
      <div style={{
        borderTop: `1px solid ${C.border}`, paddingTop: 10,
        display: "flex", flexWrap: "wrap", gap: "4px 16px",
      }}>
        <span style={{ fontSize: 11, color: C.gris, fontWeight: 600, width: "100%", marginBottom: 4 }}>
          Toujours incluses :
        </span>
        {OBLIGATOIRES.map(nom => (
          <span key={nom} style={{
            fontSize: 11, color: C.gris,
            display: "flex", alignItems: "center", gap: 4,
          }}>
            <span style={{ opacity: 0.5 }}>☑</span> {nom}
          </span>
        ))}
      </div>
    </div>
  );
}

export default ReportOptionsPanel;
